import { render, staticRenderFns } from "./CFooter.vue?vue&type=template&id=372d40c4&scoped=true&"
import script from "./CFooter.vue?vue&type=script&lang=js&"
export * from "./CFooter.vue?vue&type=script&lang=js&"
import style0 from "./CFooter.vue?vue&type=style&index=0&id=372d40c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372d40c4",
  null
  
)

export default component.exports